import { render, staticRenderFns } from "./input-wysiwyg.vue?vue&type=template&id=9490ce68&"
import script from "./input-wysiwyg.vue?vue&type=script&lang=js&"
export * from "./input-wysiwyg.vue?vue&type=script&lang=js&"
import style0 from "./input-wysiwyg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports